<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Button from "primevue/button";
import { isMobileView } from "@persolog/utils";

// Presentational: the app owns theme state (useTheme) and passes the current
// mode in via `isHighContrast`; clicking emits `toggle` for the app to apply.
const { t } = useI18n();

defineProps<{ isHighContrast?: boolean }>();
const emit = defineEmits<{ toggle: [] }>();
</script>

<template>
    <div class="theme-switcher">
        <Button
            id="theme-switcher"
            :icon="isHighContrast ? 'pi pi-eye-slash' : 'pi pi-eye'"
            @click="emit('toggle')"
            :label="!isMobileView() ? (isHighContrast ? t('themes.default') : t('themes.highContrast')) : undefined"
            :aria-label="`${t('themes.selectTheme')}: ${isHighContrast ? t('themes.default') : t('themes.highContrast')}`"
            text
            size="large"
            class="theme-toggle-btn"
        />
    </div>
</template>

<style scoped>
.theme-switcher {
    position: relative;
    border: 1px solid var(--p-border-color) !important;
}

.theme-toggle-btn {
    color: var(--p-primary-500);
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    white-space: nowrap;
}

.theme-toggle-btn:hover {
    background: var(--p-hover-background);
    border-color: var(--p-hover-border-color);
}

@media screen and (max-width: 768px) {
    .theme-toggle-btn {
        padding: 0.4rem;
        font-size: 0.8rem;
        min-width: auto;
        width: auto;
    }
}

/* High contrast theme specific styles */
:global(.theme-high-contrast) .theme-switcher {
    --p-text-color: #000000;
    --p-border-color: #000000;
    --p-hover-background: #f8f9fa;
    --p-hover-border-color: #000000;
}

:global(.theme-high-contrast) .theme-toggle-btn {
    border: 2px solid #000000 !important;
    background: #ffffff !important;
    color: #000000 !important;
}

:global(.theme-high-contrast) .theme-toggle-btn:hover {
    background: #000000 !important;
    color: #ffffff !important;
    border: 2px solid #000000 !important;
}
</style>
